"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAddToCart = void 0;
var lodash_1 = require("lodash");
var _1 = require(".");
var handleAddToCart = function (mutation, state) {
    try {
        var ports_1 = state.planning.shop.cruiseData.ports;
        var productsForTracking = state.planning.shop.productsForTracking || [];
        var products_1 = [];
        var isRecommendationProduct = state.planning.shopItem.isRecommendationProduct;
        productsForTracking.forEach(function (product) {
            products_1.push({
                name: product.name,
                id: product.id,
                price: product.price.toString(),
                category: (0, lodash_1.join)((product || {}).mainCategory, '/'),
                brand: (function () {
                    var portObject = (0, lodash_1.find)(ports_1, function (p) { return p.port.code === product.portCode; });
                    return portObject
                        ? portObject.port.name +
                            ' (' +
                            portObject.port.countryCd +
                            ')' +
                            '/' +
                            product.startDate
                        : 'none/' + product.startDate;
                })(),
                variant: (0, lodash_1.join)((product || {}).category, '/'),
                quantity: product.quantity,
                dimension31: state.planning.shop.cruiseData.cruiseIds.join('/'),
                dimension32: 'OBR',
                dimension37: state.planning.shop.cruiseData.regionNames.join('/'),
                dimension42: state.planning.shop.cruiseData.shipNames.join('/'),
                dimension43: state.planning.shop.bookingData.priceModel,
                dimension44: (0, _1.getCabinType)(state),
                dimension45: state.planning.shop.cruiseData.daysTillDeparture.toString(),
            });
        });
        var agencyId = (0, lodash_1.get)(state, 'planning.shop.agencyData.number', '');
        var events = [
            {
                event: 'EECaddToCart',
                ecommerce: {
                    currencyCode: 'EUR',
                    dimension67: agencyId,
                    add: {
                        products: products_1,
                        actionField: {
                            list: isRecommendationProduct
                                ? 'cpl_cart_recommendations'
                                : 'Cruiseplaner',
                        },
                    },
                },
            },
        ];
        return events;
    }
    catch (error) {
        console.error(error);
    }
    return [];
};
exports.handleAddToCart = handleAddToCart;
//# sourceMappingURL=add_to_cart.js.map